import moment from "moment";
import { LAB_IDENTIFIERS } from "./Config";
import { dateTypeEnums, dispatchStatusEnum } from "./Constant";

/**
 * @function getAge
 * @param {String} '01-01-2022'
 * @return {String} '50 years'
 */
const getAge = (data) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;

  if (data?.match(regex) === null) {
    return "Invalid date format, Accepted format 'YYYY-MM-DD'";
  }
  const now = new Date();

  const currentDate = moment(now, "YYYY-MM-DD");
  const parsedDate = moment(data, "YYYY-MM-DD");
  const years = currentDate.diff(parsedDate, "years");
  const months = currentDate.diff(parsedDate, "months");
  const days = currentDate.diff(parsedDate, "days");
  if (years === 0) {
    if (months === 0) {
      return `${days} days`;
    }
    return `${months} months`;
  }
  return `${years} years`;
};

export const formatAge = (birthDate) => {
  if (!birthDate) return { years: "", months: "", days: "" };

  const birth = moment(birthDate);
  const today = moment();

  const years = today.diff(birth, "years");
  birth.add(years, "years");

  const months = today.diff(birth, "months");
  birth.add(months, "months");

  const days = today.diff(birth, "days");

  return {
    years,
    months,
    days,
  };
};

// =======================================================

/**
 * @function getAgeYearMonth
 * @param {String} '01-01-2022'
 * @return {String} '50 years'
 */
const getAgeYearMonth = (data) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;

  if (data?.match(regex) === null) {
    return "Invalid date format, Accepted format 'YYYY-MM-DD'";
  }
  const now = new Date();

  const currentDate = moment(now, "YYYY-MM-DD");
  const parsedDate = moment(data, "YYYY-MM-DD");
  const years = currentDate.diff(parsedDate, "years");
  const months = currentDate.diff(parsedDate, "months");

  if (years === 0) {
    if (months === 0) {
      return { year: 0, month: 0 };
    }
    return { year: 0, month: months };
  }
  return { year: years, month: 0 };
};

// =======================================================

/**
 * @function getDoBFromAge
 * @param {String} '1970-01-01'
 * @return {Object} {'53', '4'}
 */
const getDoBFromAge = (arg) => {
  const dob = new Date(arg);
  const today = new Date();
  let ageYear = today.getFullYear() - dob.getFullYear();
  let ageMonth = today.getMonth() - dob.getMonth();

  if (ageMonth < 0 || (ageMonth === 0 && today.getDate() < dob.getDate())) {
    ageYear--;
    ageMonth += 12;
  }

  return { ageYear, ageMonth };
};

// =======================================================

/**
 * @function convertUploadSize
 * @param {String} '1004884'
 * @return {String} '150KB'
 */
const convertUploadSize = (byte) => {
  const decimals = 2;
  if (!+byte) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(byte) / Math.log(k));
  return `${parseFloat((byte / k ** i).toFixed(dm))} ${sizes[i]}`;
};

// =======================================================

/**
 * @function NGNCurrencyFormatter
 * @param {String} '100000'
 * @return {String} '₦100,000.00'
 */
const NGNCurrencyFormatter = (arg1) => {
  // var formatter = new Intl.NumberFormat('en-NGN', {
  //   style: 'currency',
  //   currency: 'NGN',
  // })

  const value = arg1.toFixed(2).split(".");
  return (
    "₦ " +
    value[0]
      .split("")
      .reverse()
      .reduce(
        (acc, num, i) => num + (num !== "-" && i && !(i % 3) ? "," : "") + acc,
        ""
      ) +
    "." +
    value[1]
  );
};

// =======================================================

/**
 * @function toUpperCaseFirst
 * @param String
 */

const toUpperCaseFirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);

// =======================================================

/**
 * @function getAgeForCalculation
 * @param {String} '01-01-2022'
 * @return {String} '50 years'
 */
const getAgeForCalculation = (data) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;

  if (data.match(regex) === null) {
    return "Invalid date format, Accepted format 'YYYY-MM-DD'";
  }
  const now = new Date();

  const currentDate = moment(now, "YYYY-MM-DD");
  const parsedDate = moment(data, "YYYY-MM-DD");
  const years = currentDate.diff(parsedDate, "years");

  return years;
};

export function fixedZero(val) {
  return val * 1 < 10 ? `0${val}` : val;
}

const getTimeDistance = (type) => {
  const now = new Date();
  const oneDay = 1000 * 60 * 60 * 24;

  if (type === "today") {
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    return [moment(now), moment(now.getTime() + (oneDay - 1000))];
  }

  if (type === "week") {
    let day = now.getDay();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);

    if (day === 0) {
      day = 6;
    } else {
      day -= 1;
    }

    const beginTime = now.getTime() - day * oneDay;

    return [moment(beginTime), moment(beginTime + (7 * oneDay - 1000))];
  }

  if (type === "month") {
    const year = now.getFullYear();
    const month = now.getMonth();
    const nextDate = moment(now).add(1, "months");
    const nextYear = nextDate.year();
    const nextMonth = nextDate.month();

    return [
      moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`),
      moment(
        moment(
          `${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`
        ).valueOf() - 1000
      ),
    ];
  }

  if (type === "year") {
    const year = now.getFullYear();

    return [moment(`${year}-01-01 00:00:00`), moment(`${year}-12-31 23:59:59`)];
  }
};

// =======================================================
/**
 * @function removeStringFormatter
 * @description remove underscore from string
 */
const removeStringFormatter = (text) => {
  if (!text) return "";
  return text?.replace(/_/g, " ");
};

const stringFormatter = (text) => {
  return text?.replace(/ /g, "_") ?? text;
};

/**
 * @function maxWords
 * @description return the maximum number of words and add ellipsis
 */

const maxWords = (str, max = 12) => {
  return str?.length > max ? `${str.substring(0, max)}...` : str;
};

const constantEnum = {
  NUMERIC: "Numeric",
  CODED: "Coded",
};

const programEnum = {
  GENERAL: "General",
  TB: "Tuberculosis",
  MPOX: "MPox",
  CSM: "CSM",
  CRS: "Congenital Rubella Syndrome (CRS)",
  LASSA: "Lassa Fever",
  CHOLERA: "Cholera",
  MEASLES: "Measles and Rubella",
  ANTHRAX: "Anthrax",
  YELLOW: "Yellow fever",
  COVID: "COVID-19",
  INFLUENZA: "Influenza",
  DIPHTHERIA: "Diphtheria",
  PUBLIC: "Public",
  EID: "EID",
  VIRAL_LOAD: "Viral Load",
  ESPN: "ESPN",
};

const isServiceOfferedEnum = {
  YES: "Yes",
  NO: "No",
};

const viewTypeEnum = {
  GRID: "grid",
  TABLE: "table",
};

const trafficData = [
  { name: "Page A", income: 200 },
  { name: "Page B", income: 900 },
  { name: "Page C", income: 600 },
  { name: "Page D", income: 1600 },
  { name: "Page D", income: 900 },
];

/**
 * @function formatSN
 * @description format serial number
 */

const formatSN = (arg) => {
  const sn = arg + 1;
  return sn < 10 ? `0${sn}` : sn;
};

export function getDispatchStatusText(statusId) {
  const statusMap = Object.entries(dispatchStatusEnum).reduce(
    (acc, [key, value]) => {
      acc[value] = key;
      return acc;
    },
    {}
  );

  return removeStringFormatter(statusMap[statusId]) || "UNKNOWN STATUS";
}

/**
 * @function getHospitalNumber
 * @description get hospital number from client identifiers
 */
export function getHospitalNumber(
  client,
  hospitalIdentifierType = LAB_IDENTIFIERS.HOSPITAL_NUMBER
) {
  return (
    client?.identifiers?.find(
      (id) => id.identifier_type === hospitalIdentifierType
    )?.identifier || "N/A"
  );
}

/**
 * @function sortByField
 * @description sort array of objects by a specific field
 */
function sortByField(data, field) {
  return data.sort((a, b) =>
    (a?.[field] ?? "").localeCompare(b?.[field] ?? "")
  );
}

/**
 * @function formQueryParametersFromCriteria
 * @description build query parameters from criteria object
 */
const formQueryParametersFromCriteria = (criteria) => {
  const params = new URLSearchParams();
  
  // Handle standard parameters
  const standardParams = ["total_pages", "page", "pageIndex", "page_size", "ordering", "search"];
  
  standardParams.forEach((key) => {
    if (criteria?.[key] !== undefined && criteria?.[key] !== "") {
      params.append(key, criteria[key]);
    }
  });
  
  // Handle all other parameters as filters
  Object.entries(criteria || {}).forEach(([key, value]) => {
    // Skip if it's a standard parameter or value is undefined/empty
    if (standardParams.includes(key) || value === undefined || value === "") {
      return;
    }
    
    // Handle arrays (e.g., ?result_status=entered&result_status=validated)
    if (Array.isArray(value)) {
      value.forEach(v => {
        if (v !== undefined && v !== "") {
          params.append(key, v);
        }
      });
    } else {
      params.append(key, value);
    }
  });
  
  const queryString = `?${params.toString()}`;
  console.log("Generated query string:", queryString);
  return queryString;
};
const containsMCS = (testType) => {
  if (!testType || typeof testType !== "string") return false;
  return testType.toLowerCase().includes("m/c/s");
};

/**
 * @function formatDate
 * @description format UTC date to users TZ
 */
const formatDate = ({
  date = moment(),
  format = dateTypeEnums.DATE_TIME,
} = {}) => {
  if (!date) return "";
  try {
    const hasTz =
      typeof moment.tz === "function" && typeof moment.tz.guess === "function";
    if (hasTz) {
      return moment.utc(date).tz(moment.tz.guess()).format(format);
    }
  } catch (e) {
    // swallow and fallback below
  }
  return moment(date).format(format);
};

/**
 * @function hasValue
 * @description check if the object's select field has value
 */
const hasValue = (val) => {
  if (val == null) return false;
  if (typeof val === "string") return val.trim() !== "";
  if (typeof val === "number") return !Number.isNaN(val);
  if (Array.isArray(val)) return val.length > 0;
  if (typeof val === "object") return Object.keys(val).length > 0;
  return true;
};

const isAndroid = /Android/i.test(navigator.userAgent);

// Parse heterogeneous date inputs into a Moment instance (or null)
function parsePossibleDate(value) {
  if (value === null || typeof value === "undefined") return null;
  // numbers (epoch seconds or ms)
  if (typeof value === "number") {
    // Heuristic: > 1e12 already ms, < 1e11 likely seconds
    const asMs = value > 1e12 ? value : value < 1e11 ? value * 1000 : value;
    const m = moment(asMs);
    return m.isValid() ? m : null;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    // Try ISO or full datetime first
    let m = moment(trimmed);
    if (m.isValid()) return m;
    // Try common date formats: YYYY-MM-DD, MM-DD, M/D, etc.
    m = moment(trimmed, ["YYYY-MM-DD", "MM-DD", "M-D", "MM/DD", "M/D"], true);
    if (m.isValid()) return m;
    // Try parsing as MM-DD with current year
    const parts = trimmed.split("-");
    if (parts.length === 2) {
      const withYear = `${moment().year()}-${trimmed}`;
      m = moment(withYear);
      if (m.isValid()) return m;
    }
    return null;
  }

  // Fallback: try to create a moment from the value
  const m = moment(value);
  return m.isValid() ? m : null;
}

// eslint-disable-next-line no-unused-vars
function formatDateLabel(m, opts = { month: "short", day: "numeric" }) {
  if (!m) return "";
  // If passed a Date or Moment-like, convert to moment
  const mm = moment.isMoment(m) ? m : moment(m);
  if (!mm.isValid()) return "";
  // Default short format like 'Nov 14'
  return mm.format("MMM D");
}

function toISODate(m) {
  if (!m) return null;
  const mm = moment.isMoment(m) ? m : moment(m);
  return mm.isValid() ? mm.format("YYYY-MM-DD") : null;
}

export {
  constantEnum,
  containsMCS,
  convertUploadSize,
  formatDate,
  formatDateLabel,
  formatSN,
  formQueryParametersFromCriteria,
  getAge,
  getAgeForCalculation,
  getAgeYearMonth,
  getDoBFromAge,
  getTimeDistance,
  hasValue,
  isAndroid,
  isServiceOfferedEnum,
  maxWords,
  NGNCurrencyFormatter,
  parsePossibleDate,
  programEnum,
  removeStringFormatter,
  sortByField,
  stringFormatter,
  toISODate,
  toUpperCaseFirst,
  trafficData,
  viewTypeEnum,
};
